import { useInfiniteQuery } from 'react-query';

import { GRAPHICS_RELATED_GRAPHICS_KEY } from '@utils/backend-api/graphics';
import { getRelatedGraphics } from '@utils/backend-api/graphics';

export default function useGraphicsRelatedGraphics(id: string | number) {
  const { data, isLoading } = useInfiniteQuery(
    [GRAPHICS_RELATED_GRAPHICS_KEY, id],
    async () => await getRelatedGraphics(id)
  );

  const relatedGraphics = data?.pages[0]?.relatedGraphics || [];

  return {
    relatedGraphics,
    isLoadingRelatedGraphicsResults: isLoading,
  };
}
